import { render } from "./QrCodeRound.vue?vue&type=template&id=1f0f5ee2"
const script = {}

import exportComponent from "../../../../../../../../projects/loyalzilla_admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/icons/QrCodeRound.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "1f0f5ee2"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('1f0f5ee2', __exports__)) {
    api.reload('1f0f5ee2', __exports__)
  }
  
  module.hot.accept("./QrCodeRound.vue?vue&type=template&id=1f0f5ee2", () => {
    api.rerender('1f0f5ee2', render)
  })

}


export default __exports__